import React from 'react';
import Card from '../card/Card';
import P from '../texts/p/P';
import theme from '../../styles/theme';

type EarlyCancellationBannerVariant = 'info' | 'warning';

interface EarlyCancellationBannerProps {
  children: React.ReactNode;
  variant?: EarlyCancellationBannerVariant;
}

const bannerStyles: Record<
  EarlyCancellationBannerVariant,
  { bg: string; border: string; textVariant: 'info' | 'warning' }
> = {
  info: {
    bg: theme.colors.info.bg.inverted,
    border: theme.colors.info.border.regular,
    textVariant: 'info',
  },
  warning: {
    bg: theme.colors.warning.bg.weak,
    border: theme.colors.warning.border.regular,
    textVariant: 'warning',
  },
};

const EarlyCancellationBanner: React.FC<EarlyCancellationBannerProps> = ({
  children,
  variant = 'info',
}) => {
  const styles = bannerStyles[variant];

  return (
    <Card
      margin={{ top: '3' }}
      borderRadius
      style={{
        backgroundColor: styles.bg,
        border: `1px solid ${styles.border}`,
        padding: `12px ${theme.spacing['spacing-3']}`,
      }}
    >
      <P
        type="3"
        variant={styles.textVariant}
        weight="regular"
        modifier="regular"
        withMargin={false}
      >
        {children}
      </P>
    </Card>
  );
};

export default EarlyCancellationBanner;
